/* [PATCH pomoc-fe v2] Vsebina pomoči — aplikacija Banka (stranka = računovodja, odločitev B4).
   Vir napisov: recon v10 (15.10.2026) iz BankaPage.tsx na testu.
   Pravilo: samo napisi, ki obstajajo v kodi. Ob spremembi zaslona posodobi tudi to datoteko. */
import { Postopek, StranPomoci, Tezava } from '../tipi';

const P_IZPISKI: Postopek = {
  id: 'banka.izpiski', naslov: 'Bančni izpiski', za: 'vsi',
  koraki: [
    'Meni **Izpiski** — stran **Bančni izpiski**. Iskanje: **Išči po vseh izpiskih …**.',
    'Seznam izpiskov: **Št.**, **Datum**, **IBAN**, **Začetno**, **Prilivi**, **Odlivi**, **Končno**, **Postavk**, **Kontrola**, **Stanje**.',
    'Klik na izpisek pokaže postavke: **Nasprotna stranka**, **Sklic / opis**, **Priliv**, **Odliv**, **Vezano na**, **Stanje**.',
    'Izpisek natisneš z **Natisni / PDF**, v ločenem oknu ga odpreš z **Izpisek v novem oknu**; **Izbriši** ga odstrani.',
  ],
};

const P_PARJENJE: Postopek = {
  id: 'banka.parjenje', naslov: 'Parjenje postavk z računi', za: 'vsi',
  koraki: [
    'Sistem postavke sam poveže z odprtimi računi in uporabi pravila; predlog sprejmeš z ikono **Sprejmi predlog**.',
    'Vez ročno urediš z ikono **Uredi vezi**: izberi račun (**Številka**, **Partner**, **Datum**, **Odprto**, **Status**) → **Dodaj**; vrstice vezi (**Račun / konto**, **Partner**, **Opis**, **Znesek**) → **Shrani**.',
    'Postavka brez računa: **Konto brez računa** — saldakontni konto zahteva partnerja.',
    'Postavko vrneš med odprte z ikono **Vrni med odprte**.',
  ],
};

const P_POTRDI: Postopek = {
  id: 'banka.potrdi', naslov: 'Potrditev izpiska', za: 'vsi',
  koraki: [
    'Ko so vse postavke rešene, klikni **Potrdi izpisek**. Okno pokaže plačila po računih (**Račun**, **Odprto pred**, **Plačilo**, **Odprto po**) → **Potrdi in zapiši plačila**.',
    '**Potrdi vse rešene** potrdi vse izpiske, kjer so vse postavke rešene.',
    'Potrditev prekličeš s **Prekliči potrditev**.',
    '**Ponovno obdelaj vse** znova poišče račune in uporabi pravila na vseh nepotrjenih izpiskih; ročne vezi ostanejo.',
  ],
};

const P_PRAVILA: Postopek = {
  id: 'banka.pravila', naslov: 'Pravila za postavke brez računa', za: 'vsi',
  koraki: [
    'Pravilo za postavko ustvariš z gumbom **☰+** v vrstici postavke (**Pravilo za to postavko**), ali v meniju **Pravila** z **Novo pravilo**.',
    'V pravilu izbereš **Smer**, konto in neobvezen opis knjižbe; **Ime pravila** je neobvezno (sicer se sestavi iz pogojev) → **Shrani pravilo**.',
    'Seznam pravil: **Pravilo**, **Smer**, **Konto**, **Izvor**, **Uporab**, **Aktivno**; **Uredi** ali **Izbriši**.',
  ],
};

const P_PRENOS: Postopek = {
  id: 'banka.prenos', naslov: 'Prenos v računovodski program', za: 'vsi',
  koraki: [
    'Meni **Prenos** — seznam potrjenih izpiskov: **Št.**, **Datum**, **Račun**, **Prilivi**, **Odlivi**, **Preneseno**.',
    'Pred prenosom si knjižbe ogledaš s **Predogled**.',
  ],
};

const P_NASTAVITVE: Postopek = {
  id: 'banka.nastavitve', naslov: 'Bančni računi', za: 'vsi',
  koraki: [
    'Meni **Nastavitve** — **Nastavitve banke — bančni računi**: **IBAN**, **Naziv**, **Konto**, **Oblika številke** (npr. {ŠT}), **Vasco simbol**, **Aktiven**.',
    'Nov račun dodaš z **Dodaj**, spremembe shraniš s **Shrani**.',
  ],
};

const T_SALDA: Tezava = { vprasanje: '»Saldakontni konto zahteva partnerja«', odgovor: 'Pri **Konto brez računa** s saldakontnim kontom izberi tudi partnerja.', za: 'vsi' };
const T_POTRDI: Tezava = { vprasanje: 'Izpiska ne morem potrditi', odgovor: 'Vse postavke morajo biti rešene (vezane na račun, konto ali pravilo).', za: 'vsi' };

export const BANKA: StranPomoci[] = [
  {
    kljuc: 'banka.izpiski', naslov: 'Bančni izpiski', za: 'vsi',
    ujema: (pot) => pot === '/banka',
    opis: 'Uvoženi bančni izpiski, parjenje postavk z računi in potrditev plačil.',
    postopki: [P_IZPISKI, P_PARJENJE, P_POTRDI, P_PRAVILA],
    tezave: [T_POTRDI, T_SALDA],
  },
  {
    kljuc: 'banka.pravila', naslov: 'Pravila', za: 'vsi',
    ujema: (pot) => pot === '/banka/pravila',
    opis: 'Pravila za postavke brez računa.',
    postopki: [P_PRAVILA],
  },
  {
    kljuc: 'banka.prenos', naslov: 'Prenos', za: 'vsi',
    ujema: (pot) => pot === '/banka/prenos',
    opis: 'Prenos potrjenih izpiskov v računovodski program.',
    postopki: [P_PRENOS],
  },
  {
    kljuc: 'banka.nastavitve', naslov: 'Nastavitve banke', za: 'vsi',
    ujema: (pot) => pot === '/banka/nastavitve',
    opis: 'Bančni računi podjetja in njihovi konti.',
    postopki: [P_NASTAVITVE],
  },
];
